(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var MOBILE = window.matchMedia('(max-width: 749px)');
    var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

    function init(root) {
      if (!root || root.getAttribute('data-ccs-ready')) return;
      var viewport = root.querySelector('[data-ccs-viewport]');
      var track = root.querySelector('[data-ccs-track]');
      var prev = root.querySelector('[data-ccs-prev]');
      var next = root.querySelector('[data-ccs-next]');
      var slider = root.querySelector('[data-ccs-slider]');
      if (!viewport || !track || !prev || !next) return;
      root.setAttribute('data-ccs-ready', 'true');

      var AUTOPLAY = root.getAttribute('data-autoplay') === 'true';
      var DELAY = Math.max(1500, parseInt(root.getAttribute('data-delay'), 10) || 4000);

      var timer = null;
      var hovering = false;
      var focused = false;
      var touching = false;
      var visible = true;

      function slides() {
        return Array.prototype.slice.call(
          track.querySelectorAll(MOBILE.matches ? '.ccs__page' : '.ccs__card')
        );
      }

      function step() {
        var list = slides();
        if (list.length > 1) return list[1].offsetLeft - list[0].offsetLeft;
        return viewport.clientWidth;
      }

      function maxScroll() {
        return viewport.scrollWidth - viewport.clientWidth;
      }

      function update() {
        var max = maxScroll();
        root.classList.toggle('ccs--no-nav', max <= 2);
        prev.disabled = viewport.scrollLeft <= 2;
        next.disabled = viewport.scrollLeft >= max - 2;
      }

      function behavior() {
        return REDUCED.matches ? 'auto' : 'smooth';
      }

      function go(dir) {
        viewport.scrollBy({ left: dir * step(), behavior: behavior() });
      }

      /* ---------- Autoplay ---------- */
      function canPlay() {
        return AUTOPLAY &&
          root.isConnected &&
          !REDUCED.matches &&
          !hovering &&
          !focused &&
          !touching &&
          visible &&
          !document.hidden &&
          maxScroll() > 2;
      }

      function stop() {
        if (timer) {
          clearTimeout(timer);
          timer = null;
        }
      }

      function schedule() {
        stop();
        if (!canPlay()) return;
        timer = setTimeout(tick, DELAY);
      }

      function tick() {
        timer = null;
        if (!canPlay()) return;
        if (viewport.scrollLeft >= maxScroll() - 2) {
          viewport.scrollTo({ left: 0, behavior: behavior() });
        } else {
          go(1);
        }
        schedule();
      }

      var ticking = false;
      viewport.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          update();
          ticking = false;
        });
      }, { passive: true });

      prev.addEventListener('click', function () { go(-1); schedule(); });
      next.addEventListener('click', function () { go(1); schedule(); });

      viewport.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); schedule(); }
        if (e.key === 'ArrowRight') { e.preventDefault(); go(1); schedule(); }
      });

      if (AUTOPLAY) {
        /* Pause while a mouse hovers the slider; resume on leave */
        var hoverTarget = slider || root;
        hoverTarget.addEventListener('pointerenter', function (e) {
          if (e.pointerType === 'mouse') { hovering = true; stop(); }
        });
        hoverTarget.addEventListener('pointerleave', function (e) {
          if (e.pointerType === 'mouse') { hovering = false; schedule(); }
        });

        /* Pause while touching / dragging on touch devices */
        viewport.addEventListener('touchstart', function () { touching = true; stop(); }, { passive: true });
        viewport.addEventListener('touchend', function () { touching = false; schedule(); }, { passive: true });
        viewport.addEventListener('touchcancel', function () { touching = false; schedule(); }, { passive: true });

        /* Pause while keyboard focus is inside the slider */
        root.addEventListener('focusin', function (e) {
          var kb = false;
          try { kb = e.target.matches(':focus-visible'); } catch (err) { kb = false; }
          if (kb) { focused = true; stop(); }
        });
        root.addEventListener('focusout', function () {
          focused = false;
          schedule();
        });

        document.addEventListener('visibilitychange', function () {
          if (document.hidden) stop(); else schedule();
        });

        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            visible = entries[0].isIntersecting;
            if (visible) schedule(); else stop();
          }, { threshold: 0.2 });
          io.observe(root);
        }

        if (REDUCED.addEventListener) REDUCED.addEventListener('change', schedule);
      }

      function onResize() {
        update();
        schedule();
      }

      window.addEventListener('resize', onResize);
      window.addEventListener('load', onResize);
      if (MOBILE.addEventListener) MOBILE.addEventListener('change', onResize);

      update();
      schedule();
    }

    function initAll() {
      document.querySelectorAll('[data-ccs]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target && e.target.querySelector ? e.target.querySelector('[data-ccs]') : null;
      init(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.sh-cat-trigger');
    if (trigger) {
      var header = trigger.closest('.sh-header');
      var overlay = header && header.parentElement.querySelector('#' + trigger.getAttribute('aria-controls'));
      if (overlay) {
        overlay.classList.add('is-open');
        overlay.setAttribute('aria-hidden', 'false');
        trigger.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('mc-lock-scroll');
        document.body.style.overflow = 'hidden';
        var firstCat = overlay.querySelector('.mc-cat-item');
        if (firstCat) firstCat.focus({ preventScroll: true });
      }
      return;
    }

    var closeBtn = e.target.closest('.mc-close');
    if (closeBtn) {
      closeOverlay(closeBtn.closest('.mc-overlay'));
      return;
    }

    var catItem = e.target.closest('.mc-cat-item');
    if (catItem) {
      var overlayEl = catItem.closest('.mc-overlay');
      var key = catItem.getAttribute('data-category');

      overlayEl.querySelectorAll('.mc-cat-item').forEach(function (item) {
        var isActive = item === catItem;
        item.classList.toggle('active', isActive);
        item.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      overlayEl.querySelectorAll('.mc-grid-card').forEach(function (card) {
        card.classList.toggle('is-hidden', card.getAttribute('data-category') !== key);
      });
      return;
    }

    var navToggle = e.target.closest('.sh-nav-toggle');
    if (navToggle) {
      var navItem = navToggle.closest('.sh-nav-item');
      var wasOpen = navItem.classList.contains('is-open');
      document.querySelectorAll('.sh-nav-item.is-open').forEach(function (item) {
        item.classList.remove('is-open');
        var t = item.querySelector('.sh-nav-toggle');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
      if (!wasOpen) {
        navItem.classList.add('is-open');
        navToggle.setAttribute('aria-expanded', 'true');
      }
      return;
    }

    var wishlistBtn = e.target.closest('.sh-wishlist-btn');
    if (wishlistBtn) {
      var pressed = wishlistBtn.getAttribute('aria-pressed') === 'true';
      wishlistBtn.setAttribute('aria-pressed', pressed ? 'false' : 'true');
      return;
    }

    if (!e.target.closest('.sh-nav-item')) {
      document.querySelectorAll('.sh-nav-item.is-open').forEach(function (item) {
        item.classList.remove('is-open');
        var t = item.querySelector('.sh-nav-toggle');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var openOverlay = document.querySelector('.mc-overlay.is-open');
      if (openOverlay) closeOverlay(openOverlay);
      document.querySelectorAll('.sh-nav-item.is-open').forEach(function (item) {
        item.classList.remove('is-open');
        var t = item.querySelector('.sh-nav-toggle');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    }
  });

  function closeOverlay(overlay) {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('mc-lock-scroll');
    document.body.style.overflow = '';
    var trigger = document.querySelector('.sh-cat-trigger[aria-controls="' + overlay.id + '"]');
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      trigger.focus({ preventScroll: true });
    }
  }
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["liquid-banner-carousel"] && !Shopify.designMode) return;
  try {
    
  /*
    <lbc-carousel>
    Adds looping, arrows and dots on top of a native scroll-snap list (swipe/touch is handled by the browser).
    It only activates while the list is laid out as a carousel (mobile always, desktop when enabled)
    AND there are more slides than fit in view. Otherwise it removes its clones and stays out of the way.
  */
  if (!customElements.get('lbc-carousel')) {
    class LbcCarousel extends HTMLElement {
      connectedCallback() {
        if (this.ready) {
          this.resizeObserver.observe(this.list);
          this.layout();
          return;
        }

        const list = this.querySelector('.lbc__list');
        if (!list || list.children.length < 2) return;

        this.list = list;
        this.slides = Array.from(list.children);
        this.count = this.slides.length;
        this.dots = Array.from(this.querySelectorAll('[data-lbc-dot]'));
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.k = 0; // clones on each side; 0 = carousel inactive
        this.index = 0; // real index of the first visible slide
        this.target = null; // raw index of an in-flight smooth scroll
        this.stride = 1; // slide width + gap
        this.sign = 1; // 1 = LTR, -1 = RTL
        this.touching = false;
        this.timer = 0;
        this.frame = 0;
        this.ready = true;

        const hasScrollEnd = 'onscrollend' in window;

        list.addEventListener(
          'scroll',
          () => {
            if (!this.k) return;
            cancelAnimationFrame(this.frame);
            this.frame = requestAnimationFrame(() => this.sync());
            if (!hasScrollEnd) this.queueSettle();
          },
          { passive: true }
        );

        if (hasScrollEnd) list.addEventListener('scrollend', () => this.settle());

        const release = () => {
          this.touching = false;
          if (!hasScrollEnd) this.queueSettle();
        };
        list.addEventListener('touchstart', () => (this.touching = true), { passive: true });
        list.addEventListener('touchend', release, { passive: true });
        list.addEventListener('touchcancel', release, { passive: true });

        const prev = this.querySelector('[data-lbc-prev]');
        const next = this.querySelector('[data-lbc-next]');
        if (prev) prev.addEventListener('click', () => this.move(-1));
        if (next) next.addEventListener('click', () => this.move(1));
        this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.goTo(i)));

        // Theme editor: bring a selected block into view
        this.addEventListener('shopify:block:select', (event) => {
          const i = this.slides.indexOf(event.target);
          if (i > -1 && this.k) this.goTo(i, false);
        });

        this.resizeObserver = new ResizeObserver(() => this.layout());
        this.resizeObserver.observe(list);
        this.layout();
      }

      disconnectedCallback() {
        if (!this.ready) return;
        this.resizeObserver.disconnect();
        clearTimeout(this.timer);
        cancelAnimationFrame(this.frame);
      }

      /* Measure the current layout, add/remove clones and re-align to the current slide */
      layout() {
        const list = this.list;
        const style = getComputedStyle(list);
        const slideWidth = this.slides[0].getBoundingClientRect().width;
        if (!slideWidth) return; // hidden

        const gap = parseFloat(style.columnGap) || 0;
        const view = Math.max(1, Math.round((list.clientWidth + gap) / (slideWidth + gap)));
        const isCarousel = style.display === 'flex';
        const k = isCarousel && this.count > view ? view : 0;

        if (k !== this.k) this.rebuild(k);

        this.stride = slideWidth + gap;
        this.sign = style.direction === 'rtl' ? -1 : 1;
        this.toggleAttribute('data-lbc-active', k > 0);

        if (k) {
          this.setAttribute('role', 'region');
          this.setAttribute('aria-roledescription', 'carousel');
          if (this.dataset.label) this.setAttribute('aria-label', this.dataset.label);
          this.jump(this.index);
          this.sync();
        } else {
          ['role', 'aria-roledescription', 'aria-label'].forEach((name) => this.removeAttribute(name));
        }
      }

      /* Clone k slides at each end so the carousel can loop seamlessly */
      rebuild(k) {
        this.list.querySelectorAll('[data-lbc-clone]').forEach((el) => el.remove());
        this.k = k;
        this.target = null;
        if (!k) return;

        const clone = (slide) => {
          const el = slide.cloneNode(true);
          el.removeAttribute('data-shopify-editor-block');
          el.setAttribute('data-lbc-clone', '');
          el.setAttribute('aria-hidden', 'true');
          el.setAttribute('inert', '');
          el.querySelectorAll('a, button').forEach((node) => node.setAttribute('tabindex', '-1'));
          el.querySelectorAll('img').forEach((img) => {
            img.loading = 'lazy';
            img.removeAttribute('fetchpriority');
          });
          return el;
        };

        this.list.prepend(...this.slides.slice(-k).map(clone));
        this.list.append(...this.slides.slice(0, k).map(clone));
      }

      pos() {
        return this.list.scrollLeft * this.sign;
      }

      raw() {
        return Math.round(this.pos() / this.stride);
      }

      /* Instantly show real slide i as the first visible slide */
      jump(i) {
        this.list.scrollLeft = (i + this.k) * this.stride * this.sign;
      }

      /* Update the dots to the first visible slide */
      sync() {
        const n = this.count;
        this.index = (((this.raw() - this.k) % n) + n) % n;
        this.dots.forEach((dot, i) => {
          if (i === this.index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }

      /* Once scrolling has stopped inside the clones, jump to the identical real slide */
      settle() {
        if (!this.k || this.touching) return;
        this.target = null;
        const n = this.count;
        const real = this.raw() - this.k;
        if (real < 0 || real >= n) this.jump(((real % n) + n) % n);
        this.sync();
      }

      queueSettle() {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.settle(), 120);
      }

      move(direction) {
        this.scrollToRaw((this.target ?? this.raw()) + direction);
      }

      /* Go to real slide i using whichever copy (real or clone) is closest */
      goTo(i, smooth = true) {
        const from = this.target ?? this.raw();
        const max = this.count + this.k;
        const raw = [i + this.k - this.count, i + this.k, i + this.k + this.count]
          .filter((r) => r >= 0 && r <= max)
          .reduce((best, r) => (Math.abs(r - from) <= Math.abs(best - from) ? r : best));
        this.scrollToRaw(raw, smooth);
      }

      scrollToRaw(raw, smooth = true) {
        const clamped = Math.max(0, Math.min(raw, this.count + this.k));
        const left = clamped * this.stride;
        if (Math.abs(left - this.pos()) < 1) return;

        const animate = smooth && !this.reduceMotion.matches;
        this.target = animate ? clamped : null;
        this.list.scrollTo({ left: left * this.sign, behavior: animate ? 'smooth' : 'auto' });
      }
    }

    customElements.define('lbc-carousel', LbcCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
